module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-back-button"
    }
  }, [_c('span', {
    staticClass: "internal",
    on: {
      "click": _vm.backButtonClick
    }
  }, [_c('a', [_vm._v("« Back")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-25f3ff46!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!/Users/andrewkahn/Documents/experiments/slate-interactives/src/components/slate-int-back-button/src/BackButton.vue
// module id = 109
// module chunks = 0